import { noop } from 'lodash';
import PropTypes from 'prop-types';
import React from 'react';
import styled from 'styled-components';
import LocationCard from '../../../Shared/LocationCard/index';

const LocationContainer = styled.div`
    margin: 40px 0;

    &:first-child {
        margin-top: 20px;
    }
`;

export default class ProfileLocations extends React.PureComponent {
    static propTypes = {
        expandedLocations: PropTypes.objectOf(PropTypes.bool),
        expandLocation: PropTypes.func,
        locations: PropTypes.arrayOf(PropTypes.object),
        providerId: PropTypes.string,
        showMap: PropTypes.func,
    };

    static defaultProps = {
        expandedLocations: {},
        expandLocation: noop,
        locations: [],
        showMap: noop,
    };

    render() {
        const {
            expandedLocations,
            expandLocation,
            locations,
            providerId,
            showMap,
        } = this.props;
        return (
            <div>{locations.map(loc => (
                <LocationContainer key={loc.id}>
                    <LocationCard
                        location={loc}
                        onClickExpandMap={showMap}
                        onToggleShowMore={expandLocation}
                        providerId={providerId}
                        showingMore={expandedLocations[loc.id]}
                    />
                </LocationContainer>
            ))}
            </div>
        );
    }
}
